import React, { memo, useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import RcPagination from 'rc-pagination';
import KeepAlive, { useActivate, useUnactivate } from 'react-activation';

import { logging, logPostInfo } from '../../actions/log';
import Loading from '../../components/Loading/Loading';
import ASoftCard from '../../components/ASoftCard/ASoftCard';
import { getAClassApps, getAClassesList } from '../../actions/acategory';
import styles from './ACategory.module.less';
import { categoryKeys } from '../../constants/storageKeys';

const selectAllClassesList = createSelector(
  state => state.acategory,
  acategory => acategory.classes,
);

const selectAllClassApps = createSelector(
  state => state.acategory,
  acategory => acategory.classApps,
);
const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

function ACategory(props) {
  // export default memo(() => {
  const dispatch = useDispatch();
  const classes = useSelector(selectAllClassesList);
  const classApps = useSelector(selectAllClassApps);
  const logInfoData = useSelector(selectLogInfo);
  const { match } = props;

  const pageSize = 30;
  const [activitData, setActivitData] = useState({
    code: 'game',
    classId: '',
    className: '',
    tagId: '-1',
    tagName: '全部',
    tags: [],
    pageNum: 1,
    skip: 0,
    limit: pageSize,
  });

  /**
   * 统计页面浏览时长
   */
  useEffect(() => {
    const initTime = +new Date();
    return () => {
      const leaveTime = +new Date();
      dispatch(
        logging({
          category: 'I',
          action: 'View_Time',
          label: '',
          param2: {
            source: `A_Classify`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            initTime,
            leaveTime,
            time: leaveTime - initTime,
          },
        }),
      );
    };
  }, []);

  useEffect(() => {
    // 首先获取sessionStorage中的codeClassTag
    let codeClassTag = JSON.parse(sessionStorage.getItem(categoryKeys.A_CODE_CLASS_TAG));
    if (codeClassTag && codeClassTag.code) {
      setActivitData({ ...codeClassTag });
    } else {
      codeClassTag = activitData;
      sessionStorage.setItem(categoryKeys.A_CODE_CLASS_TAG, JSON.stringify(activitData));
    }

    if (
      !classes ||
      !classes.code ||
      (classes && classes.list && classes.list.length === 0) ||
      (classes && classes.code !== activitData.code)
    ) {
      handleMenuOne(match.code || codeClassTag.code, true, codeClassTag);
    } else {
      if (classes.list && !codeClassTag.classId) {
        codeClassTag.classId = classes.list[0].classId;
        codeClassTag.className = classes.list[0].className;
        codeClassTag.tags = classes.list[0].tags;
      }
      setActivitData(codeClassTag);

      const param = {
        code: codeClassTag.code,
        id: codeClassTag.classId,
        tagid: codeClassTag.tagid,
        tagName: codeClassTag.tagName,
        skip: (codeClassTag.pageNum - 1) * pageSize,
        limit: pageSize,
      };
      dispatch(getAClassApps(param));
    }
  }, [dispatch, classes]);

  const handleMenuOne = useCallback(
    (code, flag, codeClassTagInit) => {
      const param = { code };

      if (flag) {
        // 初始化flag === true   使用传入的codeClassTag
        const codeClassTag = { ...codeClassTagInit, code };
        setActivitData(codeClassTag);
        dispatch(getAClassesList(param));
        sessionStorage.setItem(categoryKeys.A_CODE_CLASS_TAG, JSON.stringify(codeClassTag));
      } else {
        const codeClassTag = {
          ...activitData,
          code,
          classId: '',
          className: '',
          tagId: '-1',
          tagName: '全部',
          tags: [],
          pageNum: 1,
          skip: 0,
          limit: pageSize,
        };
        setActivitData(codeClassTag);
        dispatch(getAClassesList(param));
        sessionStorage.setItem(categoryKeys.A_CODE_CLASS_TAG, JSON.stringify(codeClassTag));
      }

      if (!flag) {
        // 分类页面 切换一级分类
        dispatch(
          logging({
            category: 'C',
            action: 'A_Classify',
            label: '',
            param2: {
              source: `A_Classify||${code}`,
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
              code,
            },
          }),
        );
        dispatch(
          logPostInfo({
            source: `A_Classify||${code}`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          }),
        );
      }
    },
    [activitData],
  );

  const handleMenuTwo = useCallback(
    item => {
      const param = {
        code: activitData.code,
        id: item.classId,
        tagid: '-1',
        skip: 0,
        limit: pageSize,
      };
      const codeClassTag = {
        ...activitData,
        classId: item.classId,
        className: item.className,
        tags: item.tags,
        tagId: '-1',
        tagName: '全部',
        pageNum: 1,
        skip: 0,
        limit: pageSize,
      };
      setActivitData(codeClassTag);
      dispatch(getAClassApps(param));
      sessionStorage.setItem(categoryKeys.A_CODE_CLASS_TAG, JSON.stringify(codeClassTag));

      // 分类页面 切换二级分类
      dispatch(
        logging({
          category: 'C',
          action: 'A_Classify',
          label: '',
          param2: {
            source: `A_Classify||${activitData.code}||${item.classId}`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            code: activitData.code,
            class_id: item.classId,
            class_name: item.className,
          },
        }),
      );
      dispatch(
        logPostInfo({
          source: `A_Classify||${activitData.code}||${item.classId}`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        }),
      );
    },
    [activitData],
  );

  // const handleMenuthree = useCallback((tag) => {
  //   const param = {
  //     code: activitData.code,
  //     id: activitData.classId,
  //     tagid: tag.tagId,
  //     skip: 0,
  //     limit: pageSize,
  //   };

  //   const codeClassTag = {
  //     ...activitData,
  //     tagId: tag.tagId,
  //     tagName: tag.tagName,
  //     pageNum: 1,
  //     skip: 0,
  //     limit: pageSize,
  //   }
  //   setActivitData(codeClassTag)
  //   dispatch(getAClassApps(param));
  //   sessionStorage.setItem(categoryKeys.A_CODE_CLASS_TAG, JSON.stringify(codeClassTag));

  //   // 分类页面 切换三级分类
  //   dispatch(
  //     logging({
  //       category: 'C',
  //       action: 'A_Classify',
  //       label: '',
  //       param2: {
  //         source: `A_Classify||${activitData.code}||${activitData.classId}||${tag.tagId}`,
  //         source_p: logInfoData.source_p,
  //         source_pp: logInfoData.source_pp,
  //         code: activitData.code,
  //         class_id: activitData.classId,
  //         class_name: activitData.className,
  //         tag_id: tag.tagId,
  //         tag_name: tag.tagName,
  //       },
  //     }),
  //   );
  //   dispatch(
  //     logPostInfo({
  //       source: `A_Classify||${activitData.code}||${activitData.classId}||${tag.tagId}`,
  //       source_p: logInfoData.source_p,
  //       source_pp: logInfoData.source_pp,
  //     }),
  //   );
  // }, [activitData]);

  const changePage = useCallback(
    (pageIndex, pSize) => {
      const param = {
        code: activitData.code,
        id: activitData.classId,
        tagid: activitData.tagId,
        skip: (pageIndex - 1) * pSize,
        limit: pageSize,
      };
      const codeClassTag = {
        ...activitData,
        pageNum: pageIndex,
        skip: (pageIndex - 1) * pSize,
        limit: pageSize,
      };
      setActivitData(codeClassTag);
      dispatch(getAClassApps(param));
      sessionStorage.setItem(categoryKeys.A_CODE_CLASS_TAG, JSON.stringify(codeClassTag));

      // 分类页面 点击分页打桩
      dispatch(
        logging({
          category: 'C',
          action: 'Paging',
          label: '',
          param2: {
            source: `A_Classify||${activitData.code}||${activitData.classId}||${activitData.tagId}`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            pagenum: pageIndex,
            code: activitData.code,
            class_id: activitData.classId,
            class_name: activitData.className,
            tag_id: activitData.tagId,
            tag_name: activitData.tagName,
          },
        }),
      );
    },
    [activitData],
  );

  useEffect(() => {
    // 推荐页面PV打桩  必须设备信息获取成功之后进行
    dispatch(
      logging({
        category: 'P',
        action: 'A_Classify',
        label: '',
        param2: {
          source: 'A_Classify',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source: 'A_Classify',
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
      }),
    );
  }, [dispatch]);

  return (
    <>
      <div className={styles.category}>
        <div className={styles.menu_one}>
          <div
            className={
              activitData.code === 'game' ? styles.menu_one_item_active : styles.menu_one_item
            }
            onClick={() => handleMenuOne('game')}
          >
            游戏
          </div>
          <div
            className={
              activitData.code === 'soft' ? styles.menu_one_item_active : styles.menu_one_item
            }
            onClick={() => handleMenuOne('soft')}
          >
            软件
          </div>
        </div>
        {!classes ||
        !classes.code ||
        (classes && classes.list && classes.list.length === 0) ||
        (classes && classes.code !== activitData.code) ? (
          <div className={styles.category_class_loading}>
            <Loading />
          </div>
        ) : (
          <React.Fragment>
            {classes.list && (
              <div className={styles.menu_two}>
                {classes.list.map((item, index) => (
                  <div
                    key={index}
                    className={
                      activitData.classId === item.classId
                        ? `${styles.menu_two_item_active}`
                        : styles.menu_two_item
                    }
                    onClick={() => handleMenuTwo(item)}
                  >
                    {item.className}
                  </div>
                ))}
              </div>
            )}
            <div className={styles.category_menu_three}>
              <div className={styles.middle_title}>{activitData.className}</div>
              {/* <div className={styles.menu_three}>
                  <div
                    className={
                      activitData.tagId === '-1' ?
                      styles.menu_three_item_active :
                      styles.menu_three_item
                    }
                    onClick={() => handleMenuthree({tagId: '-1', tagName: '全部'})}
                  >全部</div>
                  {activitData.tags && activitData.tags.map((tag, index) => (
                    <div
                      key={index}
                      className={
                        activitData.tagId === tag.tagId ?
                        styles.menu_three_item_active :
                        styles.menu_three_item
                      }
                      onClick={() => handleMenuthree(tag)}
                    >{tag.tagName}</div>
                  ))}
                </div> */}
            </div>
            {!classApps ||
            !classApps.apps ||
            (classApps && classApps.apps && classApps.apps.length === 0) ? (
              <div className={styles.category_apps_loading}>
                <Loading />
              </div>
            ) : (
              <React.Fragment>
                <div className={styles.category_apps}>
                  {classApps.apps.map(app => (
                    <ASoftCard
                      soft={app}
                      logInfo={{
                        source: `A_Classify||${activitData.code}||${activitData.classId}||${activitData.tagId}`,
                        code: activitData.code,
                        classname: activitData.className,
                        tagname: activitData.tagName,
                      }}
                      key={app.softID}
                    />
                  ))}
                </div>
                {classApps.count > pageSize && (
                  <div className={styles.category_pagination}>
                    <RcPagination
                      size="small"
                      current={activitData.pageNum}
                      pageSize={pageSize}
                      defaultPageSize={pageSize}
                      total={classApps.count}
                      onChange={changePage}
                      showSizeChanger
                      className={styles.page_rcpagination}
                    />
                  </div>
                )}
              </React.Fragment>
            )}
          </React.Fragment>
        )}
      </div>
    </>
  );
}
//});

export default props => (
  <KeepAlive name="ACategory">
    <ACategory {...props}></ACategory>
  </KeepAlive>
);
